<script>
  import { createEventDispatcher } from "svelte";

  export let tag = 'span'
  export let content;
  export let message;

  const dispatch = createEventDispatcher();
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<svelte:element this={ tag } class="lt-clicker" on:click|stopPropagation={ () => { dispatch('message', { type: message }) } }>
  {@html content }
</svelte:element>
